var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialKg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.847656,
    y: 0.784668,
    width: 68.5548,
    height: 68.5548,
    rx: 9.79354,
    fill: "#FFEED4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6125 16.3811C18.599 16.5084 17.5006 17.0072 16.7366 17.6917C16.0733 18.2913 15.5002 19.2146 15.2296 20.1272C15.0439 20.7586 14.9908 21.926 15.1235 22.5786C15.5268 24.5578 16.9647 26.1178 18.8749 26.6484C19.5488 26.8342 20.5676 26.8819 21.2096 26.7546C23.2419 26.346 24.8231 24.8868 25.3484 22.9289C25.5129 22.3293 25.5447 21.215 25.4227 20.6101C25.1998 19.517 24.7594 18.6733 23.9953 17.8986C22.8492 16.7419 21.2255 16.1742 19.6125 16.3811ZM22.8439 18.8431C23.0084 18.928 23.0615 19.0182 23.0615 19.2305C23.0615 19.3419 22.8917 19.5435 22.2602 20.175L21.4537 20.9815L21.5174 21.1513C21.6872 21.6448 21.5121 22.2444 21.0982 22.5946C20.4561 23.1464 19.4321 22.9182 19.0766 22.1382C18.928 21.8146 18.9439 21.3211 19.1084 20.9974C19.3896 20.4403 19.9998 20.1591 20.6047 20.3182L20.8806 20.3925L21.6394 19.6284C22.3186 18.9386 22.5096 18.7795 22.6529 18.7689C22.6741 18.7635 22.7643 18.8007 22.8439 18.8431Z",
    fill: "#EE9C1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 38.1203V48.584L20.2646 48.5734L21.3365 48.5575L21.3524 38.1044L21.363 27.6513H20.2753H19.1875V38.1203Z",
    fill: "#EE9C1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9805 29.8905C27.9593 29.9064 27.9434 34.1248 27.9434 39.2558V48.584H38.7148H49.4862L49.4756 39.2293L49.4597 29.8799H45.4536H41.4474L41.4315 32.8619L41.4209 35.8493H38.7413H36.0617V32.8832C36.0617 30.2301 36.0511 29.917 35.9768 29.8852C35.8654 29.8428 28.023 29.8428 27.9805 29.8905Z",
    fill: "#EE9C1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5879 50.4674V51.5552H35.7695H54.9512V50.4674V49.3797H35.7695H16.5879V50.4674Z",
    fill: "#EE9C1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9661 53.0251L22.982 53.6512L25.2265 53.6671L27.4657 53.6777V53.041V52.4043H25.2106H22.9502L22.9661 53.0251Z",
    fill: "#EE9C1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0732 53.041V53.6777H46.3283H48.5834V53.041V52.4043H46.3283H44.0732V53.041Z",
    fill: "#EE9C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialKg);
export default __webpack_public_path__ + "static/media/material_kg.87af6eded837b4a0a3d442eca878e235.svg";
export { ForwardRef as ReactComponent };